import React from "react";

import * as Yup from "yup";

import { withUseFormHook } from "@sinossi/mates-react-library";
import { UseFormReturn } from "react-hook-form";
import { Button, Grid } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

import {
    AUDIENCE,
    CONTENT_TYPE_FORM_CONSTANT,
    SEGREGATION_TYPE_FORM_CONSTANT
} from "commons/form-constants";

import { ZPlayFormField } from "commons/fields";
import ZPlaySelect from "commons/fields/zplay-select";
import { Trans, t } from "@lingui/macro";

const ManageContentFilterSchema = Yup.object().shape({
    title: Yup.string().max(1024)
});

class ManageContentFilter extends React.Component<{ sendDataFn: (values: any) => void } & UseFormReturn, {}> {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.props.sendDataFn)}>
                <Grid container columnSpacing={2}>
                    <Grid item xs={12} sm={6} md={12}>
                        <ZPlayFormField
                            name="title"
                            label={t({
                                id: "clb-title-description",
                                message: "Titolo/Descrizione",
                            })}
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}
                        />
                    </Grid>
                    {/*<Grid item xs={12} sm={6} md={2}>
                        <ZPlayDatePicker
                            name="startDate"
                            label={t({
                                id: "clb-startDate",
                                message: "Dal",
                            })}
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <ZPlayDatePicker
                            name="endDate"
                            label={t({
                                id: "clb-endDate",
                                message: "Al",
                            })}
                            minDate={this.props.getValues("startDate")}
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}
                            disabled={!this.props.getValues("startDate")}
                        />
                        </Grid>*/}
                    <Grid item xs={12} sm={6} md={2}>
                        <ZPlaySelect
                            name="type"
                            label={t({
                                id: "clb-type",
                                message: "Tipo"
                            })}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}>
                            {CONTENT_TYPE_FORM_CONSTANT.map(
                                (item, index) => (<option value={item.key} key={item.key}>{item.label}</option>))}
                        </ZPlaySelect>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <ZPlaySelect
                            name="segregation"
                            label={t({
                                id: "clb-segregation",
                                message: "Segregazione"
                            })}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}>
                            {SEGREGATION_TYPE_FORM_CONSTANT.map(
                                (item, index) => (<option value={item.key} key={item.key}>{item.label}</option>))}
                        </ZPlaySelect>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <ZPlaySelect
                            name="visibility"
                            label={t({
                                id: "clb-audience",
                                message: "Visibilità"
                            })}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}>
                            {AUDIENCE.map(
                                (item, index) => (<option value={item.key} key={item.key}>{item.label}</option>))}
                        </ZPlaySelect>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} marginTop={2} textAlign="right">
                        <Button
                            sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}}
                            size={"small"}
                            endIcon={<SearchIcon sx={{color: process.env.REACT_APP_DEFAULT_TEXT_COLOR}} fontSize="small"/>}
                            disabled={this.props.formState.isSubmitting}
                            type="submit">
                            <Trans id="clb-search-btn">Cerca</Trans>
                        </Button>
                    </Grid>
                </Grid>
            </form>);
    }
}

export default withUseFormHook<{}>(ManageContentFilter, ManageContentFilterSchema, {});